import React, { FC } from 'react'

import { Typography, FNOLPageWrapper, useTranslate, FNOLButton } from '@dg-shared'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { Events } from '../../../FSM/shared/constants'
import { TRANSLATIONS as T } from '../../../constants'
import { useFNOLStyles } from '../shared/styles/useStyles'

const PageAccidentForm: FC<CommonPageProps> = ({ service }) => {
  const FNOLClasses = useFNOLStyles({})
  const { t } = useTranslate(`${T.COLLISION}.accidentForm`)
  const { send } = service

  return (
    <FNOLPageWrapper breadcrumbsBtnText={t(`${T.COMMON}/back`)} breadcrumbsStepPercentage={80}>
      <Typography testId='title' type='h1' className={FNOLClasses.title}>
        {t('title')}
      </Typography>
      <Typography testId='subtitle' html={true} className={FNOLClasses.description}>
        {t('subtitle')}
      </Typography>
      <FNOLButton
        testId='nextButton'
        handleClick={() => send(Events.NEXT)}
        buttonText={t('button.yes')}
      />
      <FNOLButton
        testId='navigateButton'
        handleClick={() => send(Events.FNOL_THEFT_STOLEN_FROM_CAR)}
        buttonText={t('button.no')}
      />
    </FNOLPageWrapper>
  )
}

export default PageAccidentForm
